import {
  buildRelevanceSortCriterion,
  buildFieldSortCriterion,
  SortOrder
} from '@coveo/headless';

const { dataset } = document.getElementsByClassName(
  'coveo-search-results__main-wrapper'
)[0];

const labels = JSON.parse(dataset.localization);

export const criteriaGlobal = [
  [labels.sortRelevance, buildRelevanceSortCriterion()],
  [labels.sortAlphaAsc, buildFieldSortCriterion('title', SortOrder.Ascending)],
  [labels.sortAlphaDesc, buildFieldSortCriterion('title', SortOrder.Descending)]
];

export const criteriaDocuments = [
  [
    labels.sortAlphaAsc,
    buildFieldSortCriterion('documentname', SortOrder.Ascending)
  ],
  [
    labels.sortAlphaDesc,
    buildFieldSortCriterion('documentname', SortOrder.Descending)
  ],
  [labels.sortRelevance, buildRelevanceSortCriterion()]
];
